import type { ChangeEvent } from 'react';
import { useBlockEditFormStore } from '@ContractBuilder/modules/block-edit';
import type { BlockType } from '@domain/schemas/block.schema';
import type { ClauseType } from '@root/helpers/clauses/constants';

export const useBlockSetupForm = () => {
  const { formValues, setFormValues } = useBlockEditFormStore(({ formValues, setFormValues }) => ({
    formValues,
    setFormValues,
  }));

  const onNameChange = (event: ChangeEvent<HTMLInputElement>) =>
    setFormValues((prev) => ({ ...prev, name: event.target.value, title: event.target.value }));

  const onTypeChange = (type: BlockType) => setFormValues((prev) => ({ ...prev, type }));

  const onClauseTypeChange = (clause_type: ClauseType | undefined) =>
    setFormValues((prev) => ({ ...prev, clause_type }));

  const onClauseReferenceChange = (event: ChangeEvent<HTMLInputElement>) =>
    setFormValues((prev) => ({ ...prev, clause_reference: event.target.value }));

  return {
    formValues,
    isValid: Boolean(formValues?.name?.trim() && formValues?.type),
    onClauseReferenceChange,
    onClauseTypeChange,
    onNameChange,
    onTypeChange,
  };
};
